import { message } from "antd";
import React, { useEffect, useState } from "react";

import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Spin } from "antd"

import BusinessService from '../../../../../service/business_service'
import TopBarComponent from './../../../component/topbar_component'
import ModalComponent from './../../../component/modal_component'

const BusinessDetailPage = () => {

    const [business, setBusiness] = useState(0);
    const [emailSetups, setEmailSetups] = useState(0);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);


    useEffect(() => {
        getMerchantById(1);
        getEmailSetupByMerchantId(1);
        //eslint-disable-next-line
    }, []);



    const getMerchantById = async (id) => {
        try {
            setLoading(true);
            const res = await BusinessService.getMerchantById(id);
            setLoading(false);
            if (res.error) message.error(res.description);
            else {
                setBusiness(res.data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getEmailSetupByMerchantId = async (id) => {
        try {
            setLoading(true);
            const res = await BusinessService.getEmailSetupByMerchantId(id);
            setLoading(false);
            if (res.error) message.error(res.description);
            else {
                setEmailSetups(res.list);
            }
        } catch (error) {
            console.log(error);
        }
    }


    return (
        <div id="main-wrapper" className="admin-dashboard-demos" style={{ background: '#e0e8f3',minHeight: '700px' }} >
            <TopBarComponent />
            <div className="page-content">
                <div className="container">
                    <div className="content-area card">
                        <div className="card-innr card-innr-fix">
                            <div className="card-head d-flex justify-content-between align-items-center">
                                <h4 className="card-title mb-0">Transaction Details</h4>
                                <Link to="/transactions" className="btn btn-sm btn-auto btn-primary d-sm-block d-none"><em className="fas fa-arrow-left mr-3" />Back</Link>
                                <Link to="/transactions" className="btn btn-icon btn-sm btn-primary d-sm-none"><em className="fas fa-arrow-left" /></Link>
                            </div>
                            <div className="gaps-1-5x" />

                            <div className="gaps-3x" />
                            <h6 className="card-sub-title">Business Info</h6>
                            <ul className="data-details-list">
                                <li>
                                    <div className="data-details-head">Business Name</div>
                                    <div className="data-details-des"><strong>{business.businessName}</strong></div>
                                </li>
                                {/* li */}
                                <li>
                                    <div className="data-details-head">Description</div>
                                    <div className="data-details-des"><strong>{business.description}</strong></div>
                                </li>
                                {/* li */}
                                <li>
                                    <div className="data-details-head">Staff Size</div>
                                    <div className="data-details-des"><strong>{business.staffSize}</strong></div>
                                </li>
                                {/* li */}
                                <li>
                                    <div className="data-details-head">Address</div>
                                    <div className="data-details-des">{business.address}</div>
                                </li>
                                {/* li */}
                                <li>
                                    <div className="data-details-head">City</div>
                                    <div className="data-details-des">{business.city}</div>
                                </li>
                                <li>
                                    <div className="data-details-head">Registration Number</div>
                                    <div className="data-details-des">{business.rcNumber}</div>
                                </li>
                                {/* li */}
                                <li>
                                    <div className="data-details-head">Created At</div>
                                    <div className="data-details-des">{business.createdAt}</div>
                                </li>
                                {/* li */}
                            </ul>
                            {/* .data-details */}
                            <div className="gaps-3x" />

                            <div className="card-head d-flex justify-content-between align-items-center">
                                <h6 className="card-sub-title">Email Configs</h6>

                                <Link onClick={() => setShowModal(true)} className="btn btn-sm btn-auto btn-primary d-sm-block d-none"><em className="fas fa-add-user mr-3" />Add Email Config</Link>
                                <Link onClick={() => setShowModal(true)} className="btn btn-icon btn-sm btn-primary d-sm-none"><em className="fas fa-add-user" /></Link>
                            </div>

                            {
                                emailSetups && emailSetups.map((item, i) => {
                                    return <ul className="data-details-list">
                                        <li>
                                            <div className="data-details-head"> Name</div>
                                            <div className="data-details-des"><strong>{item.name}</strong></div>
                                        </li>
                                        <li>
                                            <div className="data-details-head"> Protocol</div>
                                            <div className="data-details-des"><strong>{item.protocol}</strong></div>
                                        </li>
                                        <li>
                                            <div className="data-details-head"> Host</div>
                                            <div className="data-details-des"><strong>{item.host}</strong></div>
                                        </li>
                                        <li>
                                            <div className="data-details-head"> Port</div>
                                            <div className="data-details-des"><strong>{item.port}</strong></div>
                                        </li>
                                        <li>
                                            <div className="data-details-head"> Username</div>
                                            <div className="data-details-des"><strong>{item.username}</strong></div>
                                        </li>
                                        <li>
                                            <div className="data-details-head"> Password</div>
                                            <div className="data-details-des"><strong>{item.password}</strong></div>
                                        </li>
                                        <li>
                                            <div className="data-details-head"> Enable Ttls</div>
                                            <div className="data-details-des"><strong>{item.enableStarttls}</strong></div>
                                        </li>


                                        {/* li */}
                                    </ul>
                                })
                            }


                        </div>
                    </div>
                    {/* .card */}
                </div>
                {/* .container */}
            </div>

            {showModal && <ModalComponent show={showModal} closeModal={() => setShowModal(false)} title="Add Email Config" >
                <div>

                    <div className="row">
                        <div className="col-md-6">
                            <div className="input-item input-with-label">
                                <label className="input-item-label">Name</label>
                                <input className="input-bordered" type="text"  />
                            </div>

                            <div className="input-item input-with-label">
                                <label className="input-item-label">Host</label>
                                <input className="input-bordered" type="text"  />
                            </div>

                            <div className="input-item input-with-label">
                                <label className="input-item-label">Protocol</label>
                                <input className="input-bordered" type="text"  />
                            </div>

                            <div className="input-item input-with-label">
                                <label className="input-item-label">Enable TTLS</label>
                                <div className="select-wrapper">
                                    <select className="input-bordered">
                                        <option value="true">Enable</option>
                                        <option value="false">Disable</option>
                                    </select>
                                </div>
                            </div>
                            {/* <div className="input-item input-with-label">
                                <label className="input-item-label">File Upload</label>
                                <div className="relative">
                                    <em className="input-file-icon fas fa-upload" />
                                    <input type="file" className="input-file" id="file-01" />
                                    <label htmlFor="file-01">Choose a file</label>
                                </div>
                            </div> */}
                        </div>
                        <div className="col-md-6">
                            <div className="input-item input-with-label">
                                <label className="input-item-label">Port</label>
                                <input className="input-bordered" type="text"  />
                            </div>
                            <div className="input-item input-with-label">
                                <label className="input-item-label">Username</label>
                                <input className="input-bordered" type="text"  />
                            </div>
                            <div className="input-item input-with-label">
                                <label className="input-item-label">Password</label>
                                <input className="input-bordered" type="text"  />
                            </div>

                        </div>
                        <div className="col-md-12">
                        <button className="btn btn-icon btn-sm btn-primary"><em className="fas fa-add-user" />Submit</button>
                    
                        </div>
                        
                    </div>

                </div>
            </ModalComponent>}
        </div>
    );

}

export default withRouter(BusinessDetailPage);
